import React from 'react';
import { useTranslation } from 'react-i18next';
const BoxDirection = ({ children }) => {
  const { i18n } = useTranslation();
  return <div dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>{children}</div>;
};
export default BoxDirection;
